var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ListPageWithCreateButton',{attrs:{"showCreateBtn":false}},[_c('template',{slot:"listDataContent"},[_c('reportCardTable',{attrs:{"loading":_vm.loading,"list_url_prop":"/student-report-cards","headers_prop":_vm.headers}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }